// Copyright (c) 2017 Deere & Company

import FacetsAccordionContainer from './facets-accordion';
import actionCreators from '../../action-creators';
import {connect} from 'react-redux';

const getStateToBindToContainerProps = state => ({
    facetFilterText: state.tcsm.wip.facetFilterText,
    facets: state.tcsm.wip.wipFacets,
    filteredTerritories: state.tcsm.wip.filteredTerritories,
    selectedSpaLevels: state.tcsm.wip.selectedSpaLevels,
    tcsmSettings: state.tcsm.wip.tcsmSettings,
    territories: state.user.territories
});

const mapBoundActionCreatorsToActionsProp = (stateProps, dispatchProps, parentProps) => {

    const {routeParams} = parentProps;

    const {
        readAmountOfUseRequests,
        readClosingAccount,
        readDuplicatePinPlate,
        readLaborRateChanges,
        readMachineStatusUpdates,
        readPipCodeRequests,
        readSpaClaims,
        resetTcsmSettingsFacet,
        resetWipFacets,
        toggleSpaLevelsListItems,
        updateFacetFilterText,
        updateFilteredTerritories,
        updateSelectedSpaLevelsList,
        updateWipFacets
    } = dispatchProps;

    return {
        ...stateProps,
        actions: {
            readAmountOfUseRequests,
            readClosingAccount,
            readDuplicatePinPlate,
            readLaborRateChanges,
            readMachineStatusUpdates,
            readPipCodeRequests,
            readSpaClaims,
            resetTcsmSettingsFacet,
            resetWipFacets,
            toggleSpaLevelsListItems,
            updateFacetFilterText,
            updateFilteredTerritories,
            updateSelectedSpaLevelsList,
            updateWipFacets
        },
        routeParams
    };

};

export default connect(getStateToBindToContainerProps, actionCreators, mapBoundActionCreatorsToActionsProp)(FacetsAccordionContainer);



// WEBPACK FOOTER //
// ./src/tcsm/wip/components/facets/index.js